import {Basic} from '@packages/systems/core/plugins';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  showEmpty: true,
  displayName: 'Text Block',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  render: Atom.getConfigShape(Basic.atoms.Block).render,
  fields: {children: TListOfElement},
});

export default config;
